import apiService from '@/services/apiService'

// Configuración de ecommerce-graciela editable desde Mantenimiento — ver
// ecommerce-graciela/docs/SPEC_ECOMMERCE_CUENTAS_v0.1.md, RF-2.
export default {
  async get() {
    const { data } = await apiService.get('/api/maintenance/ecommerce/config')
    return data?.data || {}
  },
  async update(payload) {
    const { data } = await apiService.put('/api/maintenance/ecommerce/config', payload)
    return data?.data || {}
  },
  async uploadLogo(payload) {
    const { data } = await apiService.post('/api/maintenance/ecommerce/logo', payload)
    return data?.data || {}
  },
  async uploadFavicon(payload) {
    const { data } = await apiService.post('/api/maintenance/ecommerce/favicon', payload)
    return data?.data || {}
  },
}
